interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  dark?: boolean;
  align?: 'left' | 'center';
}

export default function SectionHeading({ kicker, title, desc, dark = false, align = 'left' }: SectionHeadingProps) {
  const isCenter = align === 'center';
  return (
    <div className={isCenter ? 'max-w-3xl mx-auto text-center' : 'max-w-3xl'}>
      <span
        className={`inline-flex items-center gap-2 text-xs tracking-[0.28em] uppercase font-medium ${
          dark ? 'text-accent-400' : 'text-primary-600'
        }`}
      >
        <span className={`w-6 h-px ${dark ? 'bg-accent-400' : 'bg-primary-500'}`} />
        {kicker}
      </span>
      <h2
        className={`mt-3 text-2xl md:text-4xl font-black tracking-tight ${
          dark ? 'text-background-50' : 'text-foreground-950'
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p className={`mt-3 md:mt-4 text-sm md:text-base leading-relaxed ${dark ? 'text-foreground-300' : 'text-foreground-600'}`}>
          {desc}
        </p>
      )}
    </div>
  );
}